import Loading from "@@/core/components/shared/Loading/Loading";
import mixins from "@@/core/mixins/mixins";
import {
  BTooltip,
  BTable,
  BModal,
  BFormCheckbox,
  BButton,
} from "bootstrap-vue";

export default {
  name: "guides",
  components: {
    Loading,
    BTooltip,
    BTable,
    BModal,
    BFormCheckbox,
    BButton,
  },
  mixins: [mixins],
  data() {
    return {
      url: "admin/guides",
      allSelected: false,
      selectedGuides: Array(100).fill(false),
      btnStatus: false,
      ids: [],
      fields: [
        {
          key: "select",
          label: "",
        },
        {
          key: "id",
          label: "شناسه",
        },
        {
          key: "description",
          label: "متن",
        },
        {
          key: "mobile",
          label: "شماره همراه",
        },
        {
          key: "is_read",
          label: "وضعیت",
        },
        {
          key: "created_at",
          label: "تاریخ ثبت",
        },
        {
          key: "show",
          label: "مشاهده",
        },
        {
          key: "delete",
          label: "حذف",
        },
      ],
    };
  },
  watch: {
    selectedGuides(newVal) {
      let selectedGuides = newVal.filter((item) => item != false);
      if (selectedGuides != "") {
        this.btnStatus = true;
      } else {
        this.btnStatus = false;
      }
    },
  },
  mounted() {
    this.loadItems();
  },
  methods: {
    showItem(id) {
      this.edit = this.items.data.find((item) => item.id == id);
      if (this.edit.is_read == 0) {
        this.readGuides();
      } else {
        this.$root.$emit("bv::show::modal", "modal-show-guide");
      }
    },
    async readGuides() {
      this.disabled = true;
      this.ids.push(this.edit.id);
      let formData = new FormData();
      this.ids.forEach((id, index) => {
        formData.append(`ids[${index}]`, id);
      });
      await this.$axios
        .post(`admin/guides/multiple-read`, formData)
        .then((response) => {
          this.$root.$emit("bv::show::modal", "modal-show-guide");
          this.edit.is_read = 1;
          this.ids = [];
        })
        .catch((error) => {
          this.$root.notify(error);
        })
        .finally(() => {
          this.disabled = false;
        });
    },
    async readGuidesAll() {
      this.disabled = true;
      this.ids = this.selectedGuides.filter((item) => {
        return item != false;
      });
      let formData = new FormData();
      this.ids.forEach((item, index) => {
        formData.append(`ids[${index}]`, item.id);
      });

      await this.$axios
        .post(`admin/guides/multiple-read`, formData)
        .then((response) => {
          this.ids.forEach((item) => {
            item.is_read = 1;
          });
          this.ids = [];
          this.$root.notify(response.data.message, "success");
        })
        .catch((error) => {
          this.$root.notify(error);
        })
        .finally(() => {
          this.disabled = false;
        });
    },
    guideSelect(index, id) {
      if (!this.selectedGuides[index]) {
        this.$set(this.selectedGuides, index, id);
      } else {
        this.$set(this.selectedGuides, index, false);
      }
    },
    guideSelectAll() {
      if (this.allSelected) {
        document
          .querySelectorAll("input[notselected]")
          .forEach((e) => e.click());
      } else {
        document.querySelectorAll("input[selected]").forEach((e) => e.click());
      }
    },
  },
};
